import { UserService } from '../core/user.service';
import { ApplicationStartupService } from '../core/application-startup.service';
import { AuthService } from '../core/auth.service';
import { Component, OnInit, Input } from '@angular/core';
import { MenuItemModel } from '../shared/models/menu-item.model';
import { AjaxDataServiceService } from '@admin/core/ajax-data-service.service';
import { UrlConfigService } from 'libs/core/src/lib/url-config';
import { UrlConfigContainer } from '@admin/core/url-config';
import { map, of, switchMap } from 'rxjs';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'hr-app-menu',
  templateUrl: './app-menu.component.html',
  // template: `
  //   <header class="main" [hidden]="!isVisible">
  //     <div class="app">
  //       <!-- <h1 title="{{ 'label.Admin' | translate }}">{{ 'label.Admin' | translate }}</h1> -->
  //       <h2>
  //         <a [routerLink]="['../dashboard']">{{
  //           'label.Administration' | translate
  //         }}</a>
  //       </h2>
  //     </div>
  //     <div class="user-container">
  //       <div>
  //         <span>{{ currentUser?.userName }}</span>
  //         &nbsp;
  //       </div>
  //       <div class="user-actions">
  //         <a (click)="signOut()" style="cursor: pointer;">
  //           <span class="fa fa-sign-out"> </span>
  //         </a>
  //       </div>
  //     </div>
  //     <nav class="menu">
  //       <ul>
  //         <li *ngFor="let menuItem of menuItems">
  //           <a [routerLink]="[menuItem.routePath]">{{
  //             menuItem.displayName
  //           }}</a>
  //         </li>
  //       </ul>
  //     </nav>
  //     <br />
  //   </header>
  // `,
  styleUrls: ['./app-menu.component.css'],
  standalone: false,
})
export class AppMenuComponent implements OnInit {
  constructor(
    private app: ApplicationStartupService,
    private userService: UserService,
    private authService: AuthService,
    private ajax: AjaxDataServiceService,
    private urlService: UrlConfigService<UrlConfigContainer>,
    
    
  ) {
    this.menuItems = [];
  }

  public get isVisible() {
    return this.app.isLoaded() && this.userService.isSignedIn;
  }

  public get currentUser() {
    return this.userService.currentUser;
  }

  // @Input()
  // public menuItems: MenuItem[];

  public menuItems: MenuItem[] = [];

  ngOnInit() {
    this.authService.isAuthenticated$.pipe(switchMap(isAuth => {
          if (isAuth) {
            return this.ajax
              .getDataPaging(this.urlService.urlConfig.api.data.currentUser.menu, {}, MenuItemModel).pipe(
                map(c => { return { items: c.items } })
              );
          }
          else {
            return of({ items: [] })
          }
        }))
        .subscribe((d) => {
          this.menuItems = d.items.map(c => {
            return {
              label: c.displayName,
              routerLink: [c.routePath],
            } as MenuItem;
          });
        });
  }

  signOut(): void {
    this.authService.logout().subscribe();
  }
}
